module.exports = __webpack_public_path__ + "5a9a3e69c2833fbb9113daab3070e19c.mp3";